module.exports = __webpack_public_path__ + "static/media/soup.4cc2cf01.jpg";